import styled from 'styled-components';

export const Collapse = styled.div`
  /* transition: height 0.5s ease-out; */
  /* ${(props) => !props.isCollapseOpen && 'overflow: hidden'}; */
  /* visibility: ${(props) => (props.isCollapseOpen ? 'visible' : 'hidden')}; */
  display: ${(props) => (props.isCollapseOpen ? 'initial' : 'none')};
  height: ${(props) => (props.isCollapseOpen ? '100%' : 0)};
`;

export default Collapse;
